import React, { useState, useEffect } from 'react';
import {
    Box,
    Paper,
    Typography,
    Button,
    Alert,
    Divider,
    CircularProgress,
    Stack
} from '@mui/material';
import AssessmentIcon from '@mui/icons-material/Assessment';
import LinkIcon from '@mui/icons-material/Link';
import { useAuth } from '../components/AuthContext';
import { API_BASE_URL } from '../components/api.js';

function InteligenciaFeriado() {
    const { authenticatedFetch, logout } = useAuth();

    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(null); 
    const [stats, setStats] = useState({ tipos: 0, referencias: 0, links: 0 });

    const fetchStats = async () => {
        try {
            const response = await authenticatedFetch(`${API_BASE_URL}/api/inteligencia-feriados-stats/`);
            if (response.ok) {
                const data = await response.json();
                setStats(data);
            }
        } catch (err) {
            console.error("Erro ao buscar stats", err);
        }
    };

    useEffect(() => {
        fetchStats();
    }, [authenticatedFetch]);

    const handleTreinar = async () => {
        if (!window.confirm("Deseja recalcular as médias estatísticas dos feriados?")) return;
        setLoading(true);
        setStatus(null);
        try {
            const response = await authenticatedFetch(`${API_BASE_URL}/api/inteligencia-feriados-treinar/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
            });
            if (!response.ok) {
                if (response.status === 401) logout();
                const errData = await response.json().catch(() => ({}));
                throw new Error(errData.error || `Erro ${response.status}`);
            }
            const data = await response.json();
            setStatus({ type: 'success', msg: data.message });
            await fetchStats();
        } catch (err) {
            setStatus({ type: 'error', msg: err.message });
        } finally {
            setLoading(false);
        }
    };

    const handleAplicar = async () => {
        if (!window.confirm("Deseja aplicar as regras ao calendário completo?")) return;
        setLoading(true);
        setStatus(null);
        try {
            const response = await authenticatedFetch(`${API_BASE_URL}/api/inteligencia-feriados-aplicar/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
            });
            if (!response.ok) {
                if (response.status === 401) logout();
                const errData = await response.json().catch(() => ({}));
                throw new Error(errData.error || `Erro ${response.status}`);
            }
            const data = await response.json();
            setStatus({ type: 'success', msg: data.message });
            await fetchStats();
        } catch (err) {
            setStatus({ type: 'error', msg: err.message });
        } finally {
            setLoading(false);
        }
    };
    return (
        <Box sx={{ flexGrow: 1, p: 3, display: 'flex', flexDirection: 'column', gap: 3 }}>
            <Typography variant="h5" fontWeight="bold">
                Configurar Impacto de Feriados
            </Typography>

            {/* Mudado para Column para ocupar linhas, com maxWidth fixo igual ao seu outro código */}
            <Stack direction="column" spacing={3} sx={{ maxWidth: 600 }}>
                
                {/* LINHA 1: TREINAMENTO */}
                <Paper elevation={3} sx={{ p: 3, display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Box>
                        <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                            Treinar Base de Impacto
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Calcula os multiplicadores estatísticos baseados no histórico de vendas (2021-Atual).
                        </Typography>
                    </Box>
                    <Divider />
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <AssessmentIcon />}
                        onClick={handleTreinar}
                        disabled={loading}
                        sx={{ px: 4, py: 1.2, fontWeight: 'bold', alignSelf: 'flex-start' }}
                    >
                        {loading ? 'Processando...' : 'Treinar Modelo'}
                    </Button>
                    <Typography variant="caption" color="text.disabled">
                        Tipos: {stats.tipos} · Referências: {stats.referencias}
                    </Typography>
                </Paper>

                {/* LINHA 2: APLICAÇÃO */}
                <Paper elevation={3} sx={{ p: 3, display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Box>
                        <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                            Aplicar no Calendário
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Vincula os impactos calculados ao calendário completo para limpeza automática.
                        </Typography>
                    </Box>
                    <Divider />
                    <Button
                        variant="contained"
                        color="success"
                        startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <LinkIcon />}
                        onClick={handleAplicar}
                        disabled={loading}
                        sx={{ px: 4, py: 1.2, fontWeight: 'bold', alignSelf: 'flex-start' }}
                    >
                        {loading ? 'Processando...' : 'Aplicar Regras'}
                    </Button>
                    <Typography variant="caption" color="text.disabled">
                        Links aplicados: {stats.links}
                    </Typography>
                </Paper>

                {status && (
                    <Alert severity={status.type}>
                        {status.msg}
                    </Alert>
                )}
            </Stack>
        </Box>
    );
}

export default InteligenciaFeriado;